module.exports = __webpack_public_path__ + "img/26.74e257f0.jpg";